import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface Team {
  id: string;
  name: string;
  clubs?: {
    id: string;
    name: string;
  } | null;
}

interface TeamPlayerBreadcrumbProps {
  team: Team | null;
  playerName?: string;
}

export const TeamPlayerBreadcrumb = ({ team, playerName }: TeamPlayerBreadcrumbProps) => {
  return (
    <div className="flex items-center gap-2 mb-6 text-sm text-muted-foreground">
      <Link to="/" className="hover:text-foreground">
        My Teams
      </Link>
      <ChevronRight className="h-4 w-4" />
      {team?.clubs && (
        <>
          <span className="text-foreground">{team.clubs.name}</span>
          <ChevronRight className="h-4 w-4" />
        </>
      )}
      {team && (
        <span className="text-foreground">{team.name}</span>
      )}
    </div>
  );
};